
export const getSelectedDocType = (state) => state.registerBankInvoice.selectedClient?.doc_type;
export const getSelectedDocument = (state) => state.registerBankInvoice.selectedClient?.doc;
export const getSelectedClientGroup = (state) => state.registerBankInvoice.selectedClient?.id;